<template>
  <footer class="footer">
    <div class="container">
      <div class="row">
        <b-link class="nav-link" target="company" href="https://r4hs.com" >運営会社</b-link>
        <b-link class="nav-link" to="/privacy-policy" >プライバシーポリシー</b-link>
      </div>
    </div>
  </footer>
</template>

<script>
export default {
    name: 'site-footer',
    data: () => {
      return  {
      }
    },
    components:{
    }
  };
</script>

<style>

/* Sticky footer styles
-------------------------------------------------- */
html {
  position: relative;
  min-height: 100%;
}
body {
  /* Margin bottom by footer height */
  margin-bottom: 60px;
}
.footer {
  position: absolute;
  bottom: 0;
  width: 100%;
  /* Set the fixed height of the footer here */
  height: 60px;
  background-color: #f5f5f5;
}


/* Custom page CSS
-------------------------------------------------- */
/* Not required for template or sticky footer method. */

.container {
  width: auto;
  max-width: 680px;
  padding: 0 15px;
}
.container .text-muted {
  margin: 20px 0;
}

/* Sticky footer styles
-------------------------------------------------- */
html {
  position: relative;
  min-height: 100%;
}
body {
  /* Margin bottom by footer height */
  margin-bottom: 60px;
}
.footer {
  position: absolute;
  bottom: 0;
  width: 100%;
  /* Set the fixed height of the footer here */
  height: 60px;
  background-color: #f5f5f5;
}
 
/* Custom page CSS
-------------------------------------------------- */
/* Not required for template or sticky footer method. */
 
.container {
  width: auto;
  max-width: 960px;
  padding: 0 15px;
}
.container .text-muted {
  margin: 20px 0;
}
</style>